import { FC, Fragment } from "react";
import { useDuckFullscreen } from "duck/ui/chat/hooks/useDuckFullscreen";
import { AssistantMessage, ChatMessage } from "duck/ui/chat/types";

import { contentRendererRegistry } from "./index";

interface Props {
  content: AssistantMessage;
  isStreaming: boolean;
  message: ChatMessage;
}

const AssistantContentRenderer: FC<Props> = ({
  content,
  isStreaming,
  message,
}) => {
  const allContentRenderers = contentRendererRegistry.getAllRenderers();
  const { isFullscreen } = useDuckFullscreen();

  return (
    <>
      {content?.messages?.map((item, idx) =>
        allContentRenderers?.map((renderer, idy) => (
          <Fragment key={`${item.message_type}-${idx}-${idy}`}>
            {renderer.canRender(item)
              ? renderer.render(item, { message, isStreaming, isFullscreen })
              : null}
          </Fragment>
        ))
      )}
    </>
  );
};

export default AssistantContentRenderer;
